/**
 * Format a byte count for human-readable display.
 * Uses B below 1 KB, then KB / MB / GB with one decimal place.
 */
export function formatFileSize(
  bytes: number | null | undefined,
  fallback = '—',
): string {
  if (bytes == null) return fallback
  if (bytes === 0) return '0 B'
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  if (bytes < 1024 * 1024 * 1024) {
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
  }
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(1)} GB`
}
